/**
 * Atomic permissions. Roles (server-scoped or family-scoped) are free-form
 * named sets of these permissions, Discord-style: there are no fixed tiers.
 *
 * System permissions (e.g. exclusive mode toggle) are intentionally not
 * included here: they are not delegable and never appear in the role
 * builder UI. They are resolved directly from `systemRole === 'host_owner'`,
 * not through the role/permission system.
 *
 * See FRONTEND_REFERENCE.md section 3.
 */
export const Permission = {
    // Lifecycle
    SERVER_START: 'server.start',
    SERVER_STOP: 'server.stop',
    SERVER_RESTART: 'server.restart',
    SERVER_KILL: 'server.kill',
    // Console and logs
    CONSOLE_READ: 'console.read',
    CONSOLE_WRITE: 'console.write',
    LOGS_READ: 'logs.read',
    // Files
    FILES_READ: 'files.read',
    FILES_WRITE: 'files.write',
    FILES_DELETE: 'files.delete',
    // Mods and plugins
    MODS_INSTALL: 'mods.install',
    MODS_DELETE: 'mods.delete',
    MODS_UPDATE: 'mods.update',
    // Configuration
    CONFIG_READ: 'config.read',
    CONFIG_WRITE: 'config.write',
    // Backups
    BACKUPS_CREATE: 'backups.create',
    BACKUPS_RESTORE: 'backups.restore',
    BACKUPS_DELETE: 'backups.delete',
    // Players
    PLAYERS_KICK: 'players.kick',
    PLAYERS_BAN: 'players.ban',
    PLAYERS_WHITELIST: 'players.whitelist',
    PLAYERS_OP: 'players.op',
    // Server settings
    SETTINGS_READ: 'settings.read',
    SETTINGS_WRITE: 'settings.write',
    // Access
    ACCESS_MANAGE: 'access.manage',
    SERVER_DELETE: 'server.delete',
    // Admin (system-level, host_owner only; see runtime_config, PR seccion 6.1)
    ADMIN_CONFIG_WRITE: 'admin.config.write',
};
//# sourceMappingURL=permissions.js.map